export default function () {
  const state = {};
  return { state: state };
}
